import { TActions } from '../../../common/state/actions';
import { IAppState } from '../../../common/state/app_state';
import { jq } from '../../../json_query';
import { TInfrastructureParamName } from '../../components/advanced/params/infrastructure';

type TInfrastructureParamChangedActionType = 'filters/infrastructure/INFRASTRUCTURE_PARAM_CHANGED';

export const IInfrastructureParamChangedActionType = 'filters/infrastructure/INFRASTRUCTURE_PARAM_CHANGED' as TInfrastructureParamChangedActionType;

export interface IInfrastructureParamChangedAction {
  type: 'filters/infrastructure/INFRASTRUCTURE_PARAM_CHANGED';
  paramName: TInfrastructureParamName;
  value: boolean;
}

export const getInfrastructureParamChangedAction = (paramName: TInfrastructureParamName) => (
  value: boolean,
): IInfrastructureParamChangedAction => ({
  type: IInfrastructureParamChangedActionType,
  paramName,
  value,
});

export const infrastructureReducer = (state: IAppState, action: TActions): IAppState => {
  switch (action.type) {
    case IInfrastructureParamChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).setInfrastructureParam(action.value, action.paramName),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-infrastructure') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).setInfrastructureParam(false, action.tag.paramName),
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).unsetInfrastructureParams(),
        },
      };

    default:
      return state;
  }
};
